/**
 * jk-blocks.js — оценочные блоки карточки ЖК подаются короче (дизайн 20.08.2026).
 *
 * Пара к public/css/jk-blocks.css. Четыре задачи:
 *
 *   Б1  «Экология» / «Инвестиции» / «Кому подойдёт» — одним аккордеоном (телефон).
 *       ⛔ 26.08.2026: пункт «„Рейтинг жилого комплекса" убран» из этого списка
 *       снят — блок оценок удалён из ВЁРСТКИ совсем (решение владельца), и
 *       скрипту его больше не прячут. Подробности — там, где жила hideRatings().
 *   Б2  «Сколько комнат нужно?» — ПОД планку «Подобрать квартиру» (телефон)
 *   Б3  кнопка первого экрана: «Забронировать квартиру» → «Выбрать квартиру»
 *   Б4  юридический текст 214-ФЗ — свернуть, но не убрать (телефон)
 *
 * Б5-Б7 (окно ипотеки во весь экран, «Способы покупки» плотнее, паркинг,
 * характеристики, провал под первым экраном) скриптом не трогаются вовсе —
 * там меняются только размеры, а это дело таблицы стилей.
 *
 * ⛔ ПОЧЕМУ ЗДЕСЬ ЕСТЬ ПРОВЕРКА ШИРИНЫ, А В СОСЕДНЕМ jk-compact.js ЕЁ ПОЧТИ НЕТ.
 *    Там правила ложатся на прод-разметку, и поворот телефона в альбом
 *    (928-932 px, ШИРЕ порога 900) отменяет их сам. Здесь Б1 ПЕРЕНОСИТ
 *    содержимое секций внутрь аккордеона — переезд необратим, стилями его не
 *    отменить. Поэтому: строим только на телефоне, слушаем matchMedia change
 *    (страницу могли открыть в альбоме и повернуть в портрет), а обратно
 *    ничего не разбираем — оформление `.zb-*` в CSS живёт вне медиа-обёрток и
 *    остаётся верным при любой ширине.
 *
 * ⛔ НА ШИРОКОМ ЭКРАНЕ ЭТИ ЖЕ ТРИ СЕКЦИИ ЗАБИРАЕТ js/jk-card.js — он складывает
 *    их во вкладки `.mg-tabs` («Рейтинг / Экология / Инвестиции / Кому
 *    подойдёт», jk-card.js:1496-1505). Если страницу открыли в альбоме, карточка
 *    уже разобрала секции; выдернуть их оттуда после поворота значит оставить
 *    во вкладках пустоту. Поэтому при живых `.mg-tabs` аккордеон НЕ строим:
 *    человек остаётся с рабочими вкладками, где то же самое содержимое.
 *
 * ⛔ СОДЕРЖИМОЕ ПЕРЕНОСИМ ЖИВЫМИ УЗЛАМИ, А НЕ КОПИЕЙ: внутри цифры, которые
 *    дорисовывает код страницы (#jkEcoGrid заполняется после ответа сервера),
 *    и копия перестала бы обновляться.
 *
 * ⛔ РАБОТАЕМ ПО DOMContentLoaded, А НЕ СРАЗУ. Файл подключён через $pageJS,
 *    то есть с defer, но опросник фильтра и планку аккордеона ставят соседние
 *    скрипты, а зеркало (dev-mirror-proxy) вставляет сборку черновиков обычным
 *    <script> в конец тела — там она исполняется раньше всех штатных. Ожидание
 *    события уравнивает оба случая.
 */
(() => {
  'use strict';

  const PHONE = '(max-width: 900px)';

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  const icon = (name) => {
    const i = document.createElement('i');
    i.className = 'fas ' + name;
    i.setAttribute('aria-hidden', 'true');
    return i;
  };

  /**
   * Наблюдатель за узлом, которого ещё нет.
   *
   * ⛔ Половина того, что нам нужно, приезжает ПОЗЖЕ нас: опросник фильтра
   *    рисует js/jk-filter-results.js, планку — js/jk-compact.js, блок
   *    «Способы покупки» дорисовывается по ответу сервера. Проверка «здесь и
   *    сейчас» молча не срабатывает, а код при этом выглядит правильным.
   * ⛔ Наблюдателя обязательно снимаем: и по успеху, и по таймеру. Висящий
   *    MutationObserver на body с subtree — это вызов на каждую вставку узла
   *    до конца жизни страницы.
   */
  const waitFor = (root, tryOnce) => {
    if (tryOnce()) return;
    if (!root || !window.MutationObserver) return;
    const mo = new MutationObserver(() => { if (tryOnce()) mo.disconnect(); });
    mo.observe(root, { childList: true, subtree: root === document.body });
    setTimeout(() => mo.disconnect(), 15000);
  };

  // ─────────────────────────────────────────────────────────────────────────
  // Б1. «Экология» / «Инвестиции» / «Кому подойдёт» — одним аккордеоном
  //
  // Решение владельца 20.08: «инвестиционный потенциал, экология и природа
  // сделай одним блоком аккуратным аккордеоном, посмотри аналог как у браузерной
  // версии, а рейтинг жилого комплекса вообще удали блок».
  //
  // Аналог в браузере — `.mg-tabs`: там «Рейтинг / Экология / Инвестиции / Кому
  // подойдёт» лежат панелями в одном блоке, показана одна. На телефоне вкладки в
  // ряд не встанут, поэтому тот же смысл даём аккордеоном: заголовки видны
  // всегда, раскрывается один раздел.
  //
  // ⛔ СПИСОК РАЗДЕЛОВ ЗАШИТ ЗДЕСЬ НАМЕРЕННО И ЭТО НЕ «СПИСОК ВИДОВ ДАННЫХ».
  //    Это три конкретные секции разметки (jk_content.php:1669/1722/1761),
  //    названные владельцем поимённо. Содержимое каждой — какое есть; ни одного
  //    признака внутри мы не перечисляем, поэтому потерять категорию нечем.
  //    Секции, которой на странице нет (шаблон рисует их по условию), просто
  //    не будет в аккордеоне.
  // ─────────────────────────────────────────────────────────────────────────
  const PARTS = [
    { id: 'jkEcoSection', name: 'Экология и природа', icon: 'fa-leaf' },
    { id: 'jkInvestment', name: 'Инвестиционный потенциал', icon: 'fa-chart-line' },
    { id: 'jkTargetAudience', name: 'Кому подойдёт', icon: 'fa-users' },
  ];

  /* ⛔ hideRatings() УДАЛЕНА 26.08.2026 — ПРЯТАТЬ СТАЛО НЕЧЕГО.

     Здесь жила функция, вешавшая на #jkRatings класс zb-gone на телефоне
     (владелец 15.08: «убери рейтинг — он грузит начало»). 26.08 владелец решил
     убрать оценки из вёрстки совсем: секции больше нет в отдаваемом
     HTML, и прятать нечего.

     ⛔ УРОК НА ПАМЯТЬ, ради него этот комментарий и оставлен.
     Скрытие когда-то стояло ВНУТРИ сборки аккордеона foldSections(), ПОСЛЕ
     её досрочных выходов. 25.08 две из трёх секций-опор удалили по аудиту
     Галса, сборка стала выходить сразу — и рейтинг ВЕРНУЛСЯ на страницу
     у ЖК без секции экологии. Удаляя блок, проверь, не висит ли на нём чужая
     логика: секции были удалены верно, все сторожа зелёные — а сломался
     соседний блок, и поймал это владелец глазами. */


  function foldSections() {
    if (document.querySelector('.zb-fold')) return;          // повторный запуск
    if (document.querySelector('.mg-tabs')) return;          // карточка-2026 уже забрала секции

    const found = [];
    for (const p of PARTS) {
      const node = document.getElementById(p.id);
      if (node) found.push({ p, node });
    }
    if (!found.length) return;


    const host = el('section', 'jk-section zb-fold');

    // ⛔ БЛОК ВСТАВЛЯЕМ ДО ПЕРЕНОСА, А НЕ ПОСЛЕ. Ниже мы забираем у первой секции
    //    её содержимое; если у секции вдруг не окажется `.jk-container`, забрать
    //    придётся саму секцию — и тогда «вставить блок перед ней» означало бы
    //    вставить его внутрь самого себя (HierarchyRequestError, страница
    //    осталась бы вообще без аккордеона). Место занимаем заранее.
    const anchor = found[0].node;
    anchor.parentNode.insertBefore(host, anchor);

    found.forEach((x, i) => {
      const row = el('div', 'zb-row');

      const btn = el('button', 'zb-row__head');
      btn.type = 'button';
      btn.setAttribute('aria-expanded', 'false');

      const ico = el('span', 'zb-row__icon');
      ico.appendChild(icon(x.p.icon));
      btn.appendChild(ico);
      btn.appendChild(el('span', 'zb-row__name', x.p.name));

      const chev = el('span', 'zb-row__chev');
      chev.appendChild(icon('fa-chevron-down'));
      btn.appendChild(chev);

      const body = el('div', 'zb-row__body');
      body.id = 'zbrow-' + i;
      body.hidden = true;
      btn.setAttribute('aria-controls', body.id);

      // Забираем содержимое БЕЗ заголовка секции: он повторял бы надпись на
      // самой строке аккордеона.
      const inner = x.node.querySelector('.jk-container') || x.node;
      const title = inner.querySelector('h2, h3');
      if (title) title.classList.add('zb-gone');
      body.appendChild(inner);
      // ⛔ ГАСИМ ИСХОДНУЮ СЕКЦИЮ, ТОЛЬКО ЕСЛИ ВЗЯЛИ ИЗ НЕЁ НУТРО. Когда
      //    `.jk-container` не нашёлся, в строку переехала сама секция — погасить
      //    её значит спрятать ровно то, что мы только что показали, и строка
      //    открывалась бы пустой. Сегодня контейнер есть у всех трёх секций
      //    (jk_content.php:1669/1722/1761), но это свойство шаблона, а не кода.
      if (inner !== x.node) x.node.classList.add('zb-gone');

      // ⛔ РАСКРЫТИЕ НЕ ДОЛЖНО УВОДИТЬ НАЖАТУЮ СТРОКУ ИЗ-ПОД ПАЛЬЦА. Содержимое
      //    появляется ПОД кнопкой, поэтому саму её не двигает; но строки ниже
      //    уезжают, а при закрытии верхнего раздела браузер может прижать
      //    страницу. Подводим ровно на разницу, 'auto' — на плавной прокрутке
      //    замер сразу после вызова врёт.
      btn.addEventListener('click', () => {
        const was = btn.getBoundingClientRect().top;
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        body.hidden = open;
        row.classList.toggle('zb-row--open', !open);
        const delta = btn.getBoundingClientRect().top - was;
        if (Math.abs(delta) > 1) window.scrollBy({ top: delta, left: 0, behavior: 'auto' });
      });

      row.appendChild(btn);
      row.appendChild(body);
      host.appendChild(row);
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Б2. «Сколько комнат нужно?» — ПОД планку «Подобрать квартиру»
  // Решение владельца 20.08.
  //
  // Почему это не CSS-порядок: узлы лежат прямыми детьми `#jkFilter`, а фильтр
  // сворачивает соседний jk-compact.js по прямым детям. Городить `order` поверх
  // чужой раскладки — значит связать две правки намертво; проще переставить
  // сам узел.
  //
  // ⛔ ОБА УЧАСТНИКА ПРИЕЗЖАЮТ ПОЗЖЕ НАС: опросник `.fq` кладёт первым ребёнком
  //    панели js/jk-filter-results.js, планку `.zjk-foldbar` — js/jk-compact.js
  //    по своему DOMContentLoaded. Поэтому ждём, а не переставляем вслепую.
  // ⛔ Опросник остаётся ВИДИМЫМ и после сворачивания фильтра: jk-compact.css
  //    прячет только `.jk-filter__head` / `__group` / `__ranges`, `.fq` в тот
  //    список не входит (решение владельца — опросник на виду).
  // ─────────────────────────────────────────────────────────────────────────
  let quizMoved = false;

  function moveQuiz() {
    if (quizMoved) return;
    waitFor(document.getElementById('jkFilter'), () => {
      if (quizMoved) return true;
      const fq = document.querySelector('#jkFilter .fq');
      const bar = document.querySelector('#jkFilter .zjk-foldbar');
      if (!fq || !bar) return false;
      quizMoved = true;
      if (fq.previousElementSibling === bar) return true;    // уже на месте
      bar.parentNode.insertBefore(fq, bar.nextSibling);
      return true;
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Б3. Кнопка первого экрана: «Забронировать квартиру» → «Выбрать квартиру».
  // Решение владельца 20.08.
  //
  // ⛔ Меняем ТОЛЬКО подпись, ничего больше: на #jkHeroContact висит обработчик
  //    js/jk.js (openLeadModal) и запись `jkHeroContact` в CARD_LEAD_SOURCES
  //    (jk-card.js) — метка источника заявки. Оба привязаны к узлу и к id, а не
  //    к тексту.
  // ⛔ Правим текстовый узел, а не `textContent` всей кнопки: внутри значок
  //    `<i class="fas fa-calendar-check">`, и перезапись текста стёрла бы его.
  // ⛔ НА ШИРОКОМ ЭКРАНЕ НАША ПОДПИСЬ НЕ ПОСЛЕДНЯЯ: js/jk-card.js ставит своё
  //    «Выбрать из N квартир» (cardSetBtnLabel, строки 509 и 2311) уже после
  //    нас — замер на 1440 это подтверждает. Ветка остаётся общей, потому что
  //    у ЖК без квартир cardFlatsLabel() возвращает пусто, и тогда видна
  //    именно наша подпись — та же по смыслу.
  // ─────────────────────────────────────────────────────────────────────────
  function renameHeroCta() {
    const btn = document.getElementById('jkHeroContact');
    if (!btn) return;
    const span = btn.querySelector('span');
    if (span && /Забронировать/i.test(span.textContent)) {
      span.textContent = 'Выбрать квартиру';
      return;
    }
    // Обёртки-span нет — правим голый текстовый узел рядом со значком.
    // ⛔ Пробел в начале обязателен: между значком и словом иначе нет зазора.
    for (const n of btn.childNodes) {
      if (n.nodeType === 3 && /Забронировать/i.test(n.nodeValue)) {
        n.nodeValue = ' Выбрать квартиру';
        return;
      }
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Б4. Юридический текст 214-ФЗ в блоке покупки — свернуть, но не убрать.
  // Владелец: «ещё уменьшить грамотно, чтоб суть не потерялась».
  //
  // ⛔ Этот текст — требование закона, а не оформление: скрывать его совсем
  //    нельзя. Сворачиваем с кнопкой «показать».
  // ⛔ ОБРЕЗКУ СТАВИТ СКРИПТ КЛАССОМ `.zb-legal-fold`, а не CSS по прод-селектору.
  //    Не отработал скрипт — нет и обрезки: закон не должен зависеть от того,
  //    успел ли исполниться наш файл.
  // ─────────────────────────────────────────────────────────────────────────
  function foldLegal() {
    waitFor(document.body, () => {
      const legal = document.querySelector('#jkMortgage .jk-legal-214fz');
      if (!legal) return false;
      if (legal.classList.contains('zb-legal-fold')) return true;   // повторный запуск

      legal.classList.add('zb-legal-fold');

      const btn = el('button', 'zb-legal-btn', 'Юридическая информация (214-ФЗ) — показать');
      btn.type = 'button';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', () => {
        const open = legal.classList.toggle('zb-legal-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open
          ? 'Юридическая информация (214-ФЗ) — свернуть'
          : 'Юридическая информация (214-ФЗ) — показать';
      });
      legal.parentNode.insertBefore(btn, legal.nextSibling);
      return true;
    });
  }

  const onPhone = () => {
    foldSections();
    moveQuiz();
    foldLegal();
  };

  const start = () => {
    renameHeroCta();

    const mq = window.matchMedia ? window.matchMedia(PHONE) : null;
    if (!mq) { onPhone(); return; }
    if (mq.matches) onPhone();
    // ⛔ Ширину СЛУШАЕМ, а не спрашиваем один раз: страницу могли открыть в
    //    альбоме (928-932 px у крупных телефонов — это ШИРЕ 900) и повернуть в
    //    портрет. Без слушателя человек остался бы без аккордеона до
    //    перезагрузки. Обратный путь разбирать не надо — см. шапку файла.
    const onChange = (e) => { if (e.matches) onPhone(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
